import { Flex, HStack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { NumberFormInput, ReadOnlyFormStat } from "components/inputs";
import {
  ContractOrderRequest,
  requestOrderInvalidNumberInputCharacters,
} from "forms/RequestOrderForm";

const NumberOfOrders = ({ unitOfMeasure }: Pick<Contract, "unitOfMeasure">) => {
  const { watch } = useFormContext<ContractOrderRequest>();

  const quantityPerOrder = watch("quantityPerOrder");
  const numberOfOrders = watch("numberOfOrders");
  const totalRequestedQuantity = quantityPerOrder * numberOfOrders;

  return (
    <HStack spacing={3} align="flex-start">
      <Flex w="89px">
        <NumberFormInput
          id="numberOfOrders"
          label="No. of Orders"
          min={1}
          invalidInputCharacters={requestOrderInvalidNumberInputCharacters}
        />
      </Flex>
      <ReadOnlyFormStat
        id="totalQuantity"
        value={`${totalRequestedQuantity} ${unitOfMeasure}`}
        label="Total Qty"
      />
    </HStack>
  );
};

export default NumberOfOrders;
